<script setup lang="ts">
    import { downloadSurveyResource, downloadSurveyQuestionResources } from '../SurveyStatistics.access';
    import type { SurveyAnswerResource } from '../../SurveysTypes.d';

    const props = defineProps<{
        responseId: string;
        questionId: string;
        resources: SurveyAnswerResource[];
        resourcePreviewUrls: Record<string, string>;
        isImageFile: (fileName: string) => boolean;
    }>();
</script>

<template>
    <template v-if="resources.length">
        <div class="form-group m-sm-b">
            <button type="button" class="btn btn-default btn-sm" @click="downloadSurveyQuestionResources(props.responseId, props.questionId)">
                {{ $Resources.DownloadAllQuestionFiles }}
            </button>
        </div>

        <ul class="files-list list-unstyled">
            <li v-for="resource in resources" :key="resource.SurveyAnswerResourceId">
                <div class="files-added-preview m-xs-b">
                    <img
                        v-if="isImageFile(resource.OriginalFileName) && resourcePreviewUrls[resource.ResourceId]"
                        class="img-responsive"
                        :src="resourcePreviewUrls[resource.ResourceId]" />
                    <span v-else-if="!isImageFile(resource.OriginalFileName)" class="c-light">[{{ $Resources.NoPreviewLabel }}]</span>
                </div>

                <button
                    class="btn btn-subtle btn-flex btn-block text-wrap text-left"
                    type="button"
                    @click="downloadSurveyResource(resource.ResourceId, resource.OriginalFileName)">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round">
                        <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                        <polyline points="13 2 13 9 20 9"></polyline>
                    </svg>
                    {{ resource.OriginalFileName }}
                </button>
            </li>
        </ul>
    </template>
</template>

